import { render } from "./PlanSaleDocuments.vue?vue&type=template&id=06c1781a"
import script from "./PlanSaleDocuments.vue?vue&type=script&lang=js"
export * from "./PlanSaleDocuments.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PlanSaleDocuments.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_2fbda9b8%2Fpackages%2Fcustomer%2Fsrc%2Fcomponents%2Fplan%2FPlanSaleDocuments.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__